import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle, faList, faUser, faCircleNotch, faHospital } from '@fortawesome/free-solid-svg-icons'

export default [
    {
        key: 'user',
        id: 'user',
        title: 'Usuarios',
        icon: <FontAwesomeIcon className='mr-75' icon={faUser} />,
    },
    
]